import createStore from "@/utils/create-store";
import Model from "@/models/admin/articles";

export default createStore({ Model });
